import * as Sentry from "@sentry/react";
import { isDomainAllowed, getSentryRelease } from "./sentryConfig";

const SENTRY_DSN = "https://d1f4f76a02d7c812763aa04eb37badfc@sentry.bimeh.com/14";

/**
 * مقداردهی اولیه Sentry.
 * فقط در production یا وقتی REACT_APP_SENTRY_ENV=test باشد فعال می‌شود.
 * هدر X-Sentry-Token حذف شده چون CORS سرور سنتری آن را مجاز نمی‌کند.
 */
export function initSentry() {
  const enabled =
    process.env.NODE_ENV === "production" ||
    process.env.REACT_APP_SENTRY_ENV === "test";
  if (!enabled) return;

  const environment =
    process.env.NODE_ENV === "production" ? "production" : "test";

  Sentry.init({
    dsn: SENTRY_DSN,
    release: getSentryRelease(),
    environment,
    sendDefaultPii: true,

    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,

    ignoreErrors: [
      /Failed to fetch/i,
      /Network Error/i,
      /NetworkError/i,
      /fetch error/i,
      /Load failed/i,
      /Loading chunk \d+ failed/i,
      /ChunkLoadError/i,
      /ResizeObserver/i,
      /Non-Error promise rejection captured/i,
      /chrome-extension/i,
      /moz-extension/i,
      /webkit-masked-url/i,
      /cancelled/i,
      /canceled/i,
      /AbortError/i,
      /Bad Request/i,
      /400/,
    ],

    denyUrls: [
      /chrome-extension:\/\//,
      /moz-extension:\/\//,
      /safari-extension:\/\//,
      /ua\.yektanet\.com/i,
      /clarity\.ms/i,
      /googletagmanager\.com/i,
      /google-analytics\.com/i,
      /hotjar\.com/i,
    ],

    beforeSend(event, hint) {
      const hostname = window.location.hostname;
      const effectivePort = window.location.port || "";

      if (!isDomainAllowed(hostname, effectivePort)) {
        return null;
      }

      const statusCode = event?.tags?.["http.status"];
      if (statusCode && Number(statusCode) >= 400 && Number(statusCode) < 500) {
        return null;
      }

      const error = hint?.originalException;
      if (error && typeof error === "string" && /ad blocker/i.test(error)) {
        return null;
      }

      if (
        event.request?.url?.includes("/api") &&
        event.message?.includes("Bad Request")
      ) {
        return null;
      }

      return event;
    },
  });

  // در محیط تست از کنسول می‌توانی sentryTest() صدا بزنی
  if (environment === "test" && typeof window !== "undefined") {
    window.sentryTest = function sentryTest() {
      Sentry.captureException(
        new Error("[تست Sentry - Tools] این خطا برای بررسی اتصال به Sentry فرستاده شده.")
      );
      console.info("خطای تست به Sentry ارسال شد.");
    };
  }
}
